import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { ElMessage } from 'element-plus'
import { getToken } from '@/utils/auth'
import { useUserStore } from '@/stores/user'
import { usePermissionStore } from '@/stores/permission'
import { useShopDataStore } from '@/stores/shopData'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login']

router.beforeEach(async (to, from, next) => {
  NProgress.start()

  const hasToken = getToken()

  if (!hasToken) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
    return
  }

  // Already logged in — redirect away from login
  if (to.path === '/login') {
    next({ path: '/' })
    NProgress.done()
    return
  }

  const userStore = useUserStore()
  const permissionStore = usePermissionStore()
  const shopDataStore = useShopDataStore()

  // Roles already loaded — route is accessible
  if (userStore.roles && userStore.roles.length > 0) {
    next()
    return
  }

  try {
    const [data] = await Promise.all([
      userStore.GetInfo(),
      shopDataStore.InitShopData()
    ])

    const { menus } = data

    permissionStore.GenerateRoutes({ menus })

    // Vue Router 4: addRoute() replaces addRoutes()
    permissionStore.addRouters.forEach(route => router.addRoute(route))

    next({ ...to, replace: true, state: to.state })
  } catch (error) {
    await userStore.FedLogOut()
    ElMessage.error(error?.message || 'Verification failed, please login again')
    next('/login')
    NProgress.done()
  }
})

router.afterEach((to) => {
  document.title = to.meta?.title ? `${to.meta.title} - JPMS` : 'JPMS'
  NProgress.done()
})
